
<template>
  <div class="blogs">
    <!-- <div class="blogs-bg">
      <div class="blogs-bg-img">
        <img src="@/assets/blogs/banner.png" alt="">
      </div>
      <div class="blogs-bg-breadcrumb">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="/">{{ $t('blogs.breadcrumb.title') }}</a></li>
            <li class="breadcrumb-item"><a href="/blogs">{{ $t('blogs.breadcrumb.activeTitle') }}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ BreadcrumbName }}</li>
          </ol>
        </nav>
      </div>
      <div class="blogs-bg-information">
        <img src="@/assets/home/xinxi.png" alt="">
      </div>
    </div> -->
    <div class="blogs-cont">
      <div class="blogs-cont-item">
        <div class="blogs-cont-item-title">
          <strong>{{ list?.title || ''}}</strong>
        </div>
        <div class="blogs-cont-item-text">
          <!-- <p>{{ list.content }}</p> -->
           <p class="content" v-html="list?.content"></p>
        </div>
        <!-- <div class="blogs-cont-item-img">
          <img :src="list.image" alt="">
        </div>
        <div class="blogs-cont-item-text">
          <p>{{ list.text }}{{ list.text }}{{ list.text }}{{ list.text }}{{ list.text }}{{ list.text }}{{ list.text }}{{ list.text }}{{ list.text }}{{ list.text }}</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsDetail } from '@/api/komo'
export default {
  name: 'blogsDetail',
  data() {
    return {
      id: 0,
      list: {},
      BreadcrumbName:''
    };
  },

  methods: {
    async getNewsDetailData(id) {
      try {
        this.list = {};
        const res = await getNewsDetail(id);
        if (res && res.data?.list) {
          this.list = res.data.list;
        } else {
          this.list = {};
        }
      } catch (error) {
        console.error('获取新闻详情失败:', error);
        this.list = {};
      } finally {
      }
    },
  },
  onShow() {
    
    },
  watch: {
        '$route': {
            immediate: true,
            handler(to) {
                 console.log('watch', to);
                if (to.name === 'blogsDetailMo') { // 确保是当前详情页路由
                  this.id = to.params.id;
                  console.log('watch搜索页详情', this.id);
                  this.getNewsDetailData(this.id);
                }
            }
        }
    },

};
</script>

<style scoped>
/* 样式部分 */
.blogs {
  width: 100%;
  height: 100%;
  background: #F8F9FC;
}
/* 内容 */
.blogs-cont{
  width: 100%;
  height: 100%;
  padding: 4% 0 6%;
   min-height: calc(100vh - var(--nav-max-height) - var(--nav-max-bottom-height));
}
.blogs-cont-item{
  width: 90%;
  height: 100%;
  margin: 0 auto;
}
.blogs-cont-item-title{
  font-size: 5vw;
  color: #1E1E1E;
  margin-bottom: 1%;
}
.blogs-cont-item-text{
  margin-bottom: 2%;
}
 .content :deep(img) {
  width: 100% !important;
  height: 100%;
}
.blogs-cont-item-text p{
  font-size: 3vw;
  color: #959595;
  line-height: 4vw;
}
.blogs-cont-item-img{
  width: 100%;
  /* height: 40vw; */
  margin-bottom: 2%;
}
.blogs-cont-item-img img{
  width: 100%;
  height: 100%;
}
</style>